export default __webpack_public_path__ + "static/media/Linkedin Learning Path Become a Software Developer.136b06ed.webp";